<div class="modal-container">
  @if(isMobileDevice){
    <div class="rectangle-line-mobile-view mt-2" mat-dialog-close>
      <img src="../../../assets/images/rectangle-line.svg" />
    </div>
  }
  <mat-dialog-content class="modal-content">
    <div class="modal-heading">
      <div class="close-button" mat-button mat-dialog-close>
        <mat-icon class="close-icon">close</mat-icon>
      </div>
    </div>

    <div class="container">
      <div class="inner-container">
        <div class="image-container">
          <img src="/assets/images/success.svg" class="image" />
        </div>
      </div>
      <div class="text-container">
        <h1 class="title">Added to Reach-List Successfully</h1>
        <span class="content"
          >You can now track reach-list under ‘reached’ tab</span
        >
      </div>
      <div class="form-actions" mat-dialog-close>
        <button class="save-button dp-primary-btn">Finish</button>
      </div>
    </div>
  </mat-dialog-content>
</div>
